import { api2 } from "../controllers/api";
import { fieldContainsValue } from "../controllers/common";

export const addFreshLeadAPI = async (data) => {
  try {
    const result = await api2.post(`/crm/leads`, data);
    return result;
  } catch (error) {
    throw error;
  }
};

export const getLeadListAPI = async (query = "limit=10000") => {
  try {
    const result = await api2.get(`/crm/leads?${query ? query : ""}`);
    return result;
  } catch (error) {
    throw error;
  }
};
export const getLeadListCsvAPI = async (query) => {
  try {
    const url = `/crm/leads?${query ? query : ""}`;
    const result = await api2.getData(url);
    return result;
  } catch (error) {
    throw error;
  }
};
export const getLeadListStatsAPI = async () => {
  try {
    const url = `/crm/leads/stats`;
    const result = await api2.get(url);
    return result;
  } catch (error) {
    throw error;
  }
};
export const getLeadDetailsAPI = async (leadId) => {
  try {
    const url = `/crm/leads/${leadId}`;
    const result = await api2.get(url);
    return result;
  } catch (error) {
    throw error;
  }
};

export const getLeadHistoryAPI = async (leadId) => {
  try {
    const url = `/crm/leads/${leadId}/history`;
    const result = await api2.get(url);
    return result;
  } catch (error) {
    throw error;
  }
};

export const viewPhoneAPI = async (id, location) => {
  try {
    const url = `/crm/leads/${id}/unmask_phone`;
    const result = await api2.get(url, location);
    return result;
  } catch (error) {
    throw error;
  }
};

export const getCrmDispositionListAPI = async () => {
  try {
    const url = `/crm/dispositions?type=mannual`;
    const result = await api2.get(url);
    return result;
  } catch (error) {
    throw error;
  }
};
export const getAgentStatusAPI = async () => {
  try {
    const url = `/crm/shift_log/me`;
    const result = await api2.get(url);
    return result;
  } catch (error) {
    throw error;
  }
};

export const updateAgentStatusAPI = async (data) => {
  try {
    const url = `/crm/shift_log/toggle`;
    const result = await api2.post(url, data);
    return result;
  } catch (error) {
    throw error;
  }
};

export const getCrmTodayLeadListAPI = async (query) => {
  try {
    const url = `/crm/leads/today?${query ? query : ""}`;
    const result = await api2.get(url);
    return result;
  } catch (error) {
    throw error;
  }
};
export const getCrmTodayLeadListCSVAPI = async (query) => {
  try {
    const url = `/crm/leads/today/?response_type=csv&${query ? query : ""}`;
    const result = await api2.getData(url);
    return result;
  } catch (error) {
    throw error;
  }
};
export const crmManualLeadCallAPI = async (data) => {
  try {
    const url = `/crm/call/manual`;
    const result = await api2.post(url, data);
    return result;
  } catch (error) {
    throw error;
  }
};
export const crmLeadCallAPI = async (data) => {
  try {
    const url = `/crm/call/leads`;
    const result = await api2.post(url, data);
    return result;
  } catch (error) {
    throw error;
  }
};

export const crmLeadDocUploadAPI = async (id, data) => {
  try {
    const url = `/crm/leads/${id}/files`;
    const result = await api2.postData(url, data);
    return result;
  } catch (error) {
    throw error;
  }
};

export const crmCallHangupAPI = async (data) => {
  try {
    const url = `/crm/call/hangup`;
    const result = await api2.post(url, data);
    return result;
  } catch (error) {
    throw error;
  }
};

export const updateCrmLeadDetailsAPI = async (leadId, data) => {
  try {
    const url = `/crm/leads/${leadId}`;
    const result = await api2.put(url, data);
    return result;
  } catch (error) {
    throw error;
  }
};

export const getCrmLeadCallHistoryAPI = async (leadId) => {
  try {
    const url = `/crm/leads/${leadId}/call_history`;
    const result = await api2.get(url);
    return result;
  } catch (error) {
    throw error;
  }
};

export const getCrmLeadDateHistoryAPI = async (leadId, dateKey) => {
  try {
    const url = `/crm/leads/${leadId}/history/${dateKey}`;
    const result = await api2.get(url);
    return result;
  } catch (error) {
    throw error;
  }
};

export const getCrmLeadPaymentDetailAPI = async (id) => {
  try {
    const url = `/crm/leads/${id}/payments`;
    if (!fieldContainsValue(id)) {
      throw "id is required";
    }
    const result = await api2.get(url);
    return result;
  } catch (error) {
    throw error;
  }
};

export const getCrmLeadListFiltersOptionsAPI = async (query) => {
  try {
    const url = `/crm/leads/filters${query ? query : ""}`;
    const result = await api2.get(url);
    return result;
  } catch (error) {
    throw error;
  }
};

export const getCrmTodayListFiltersOptionsAPI = async (query) => {
  try {
    const url = `/crm/leads/today/filters${query ? query : ""}`;
    const result = await api2.get(url);
    return result;
  } catch (error) {
    throw error;
  }
};

export const getHubListForCRMAPI = async () => {
  try {
    const url = `/hub/cached`;
    const result = await api2.get(url);
    return result;
  } catch (error) {
    throw error;
  }
};

export const verifyCrmLeadUberIdAPI = async (id) => {
  try {
    const url = `/crm/leads/check/uber_id`;
    const result = await api2.post(url, { uberId: id });
    return result;
  } catch (error) {
    throw error;
  }
};

export const checkCrmUniqueFieldAPI = async (data) => {
  try {
    const url = `/crm/leads/search_by_key`;
    const result = await api2.post(url, data);
    return result;
  } catch (error) {
    throw error;
  }
};

export const getTcCallHistoryAPI = async (query) => {
  try {
    const url = `/crm/call/history?${query ? query : ""}`;
    const result = await api2.get(url);
    return result;
  } catch (error) {
    throw error;
  }
};

export const getTcCallHistoryFiltersOptionsAPI = async (query) => {
  try {
    const url = `/crm/call/history/filters${query ? query : ""}`;
    const result = await api2.get(url);
    return result;
  } catch (error) {
    throw error;
  }
};
